import { HHStack, HHTypography } from '@hinge-health/react-component-library';
import { CSSProperties } from 'react';
import { ContractInput } from '../../context/types';
import { summarizeInput } from '../../utils/summarize-input';

const tabular: CSSProperties = { fontVariantNumeric: 'tabular-nums' };

const monoBox: CSSProperties = {
  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
  fontSize: 13,
};

interface RowProps {
  label: string;
  value: string;
  mono?: boolean;
}

const Row = ({ label, value, mono }: RowProps): JSX.Element => (
  <HHStack
    direction="row"
    spacing={2}
    sx={{
      py: 0.5,
      borderBottom: '1px solid rgba(0,0,0,0.06)',
      '&:last-of-type': { borderBottom: 'none' },
    }}
  >
    <HHTypography hhVariant="body" sx={{ width: 220, opacity: 0.7 }}>
      {label}
    </HHTypography>
    <HHTypography
      hhVariant="body"
      sx={mono ? { ...tabular, ...monoBox } : tabular}
    >
      {value}
    </HHTypography>
  </HHStack>
);

interface InputSummaryViewProps {
  input: ContractInput;
}

export const InputSummaryView = ({
  input,
}: InputSummaryViewProps): JSX.Element => {
  const s = summarizeInput(input);
  return (
    <HHStack spacing={1} sx={{ maxWidth: 720 }}>
      <Row label="Client" value={s.client} />
      <Row label="Tax ID" value={s.taxId} mono />
      <Row label="Group NPI-2" value={s.groupNpi2} mono />
      <Row
        label="Effective"
        value={`${s.effectiveStart} → ${s.effectiveEnd}`}
        mono
      />
      <Row label="Merchants" value={String(s.merchantCount)} />
      <Row label="Locations" value={String(s.locationCount)} />
      <Row
        label="Practitioners"
        value={`${s.practitionerCount} (${s.practitionersWithoutNpi} with no NPI)`}
      />
      <Row label="Cat A codes" value={String(s.catACount)} />
      <Row label="Cat B codes (pre-expansion)" value={String(s.catBCount)} />
      <Row label="Cat C excluded" value={String(s.catCExcludedCount)} />
      {s.rateLine != null && <Row label="Case rate" value={s.rateLine} />}
    </HHStack>
  );
};
